"use strict";
export function shouldSkipExceptionUpdate(updateRequestedAt, lastDocumentSaveTime) {
  if (lastDocumentSaveTime == null) return false;
  return updateRequestedAt <= lastDocumentSaveTime;
}
